import {
	resetTables,
	selectHallmapConflictedTables,
	selectHallmapSelectedTables,
} from 'entities/hallmap';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { TagCard } from 'shared/ui/cards/tagCard';
import { Button, Container } from './styles';
import { Flex } from 'shared/ui/flex';
import { LabelText } from 'shared/ui/label';
import { Table } from 'shared/lib/core';
import { useCallback, useEffect, useState } from 'react';
import { Typography } from 'shared/ui/typography';
import lock from 'assets/icons/lock.svg';
import lockOpen from 'assets/icons/lock-open.svg';
import { Img } from 'shared/ui/imgStyledComponent';
import { SECONDARY_BG_COLOR } from 'shared/consts';
import { selectOrderBookingData, updateHoldResources } from 'entities/orders';

const MAX_BIG_RESOURCES = 5;

export const ResourcesPanel = () => {
	const confictedTables = useAppSelector(selectHallmapConflictedTables);
	const selectedResources = useAppSelector(selectHallmapSelectedTables);
	const orderBookingData = useAppSelector(selectOrderBookingData);
	const [resources, setSelectedResources] = useState<Table[]>([]);
	const [labelText, setLabelText] = useState('Выбранные столы');
	const dispatch = useAppDispatch();

	const showBigResources = resources.length <= MAX_BIG_RESOURCES;

	const deleteResource = (table: Table) => {
		table.deselect();
	};

	const handleChangeHoldResources = useCallback(() => {
		dispatch(updateHoldResources({ hold_resources: !orderBookingData?.hold_resources }))
	}, [dispatch, orderBookingData])

	useEffect(() => {
		setSelectedResources(selectedResources);
	}, [selectedResources, confictedTables]);

	useEffect(() => {
		if (selectedResources.length) {
			setSelectedResources(selectedResources);
			setLabelText('Выбранные столы');
		} else {
			setLabelText('Не выбраны столы');
		}
	}, [selectedResources]);

	useEffect(() => {
		dispatch(resetTables());
	}, [dispatch]);

	return (
		<Flex $width="100%" style={{ background: SECONDARY_BG_COLOR }}>
			<Container $showBigResources={showBigResources}>
				<Flex $direction="column" $alignItems="center" $padding="4px 8px">
					{selectedResources.length ? (
						<LabelText>{labelText}</LabelText>
					) : (
						<Typography
							mode="h2"
							colorVariant="danger"
							isBold
							style={{ marginTop: '24px' }}
						>
							{labelText}
						</Typography>
					)}
					<Flex $wrap="wrap" $gap="4px">
						{resources.map(resource => {
							return (
								<TagCard
									key={resource.options.name}
									name={resource.options.name}
									typographyProps={{
										mode: showBigResources ? 'h1' : 'medium',
									}}
									onClick={() => {
										if (orderBookingData?.hold_resources) {
											return;
										}
										deleteResource(resource);
									}}
									border={
										resource.isSelected && !resource.isActive
											? 'red'
											: ''
									}
								/>
							);
						})}
					</Flex>
				</Flex>
			</Container>
			<Button onClick={handleChangeHoldResources}>
				{orderBookingData?.hold_resources ? (
					<Img src={lock} $size="large" />
				) : (
					<Img src={lockOpen} $size="large" />
				)}
			</Button>
		</Flex>
	);
};
